import { createBrowserHistory } from 'history';
export default createBrowserHistory({});
//# sourceMappingURL=history.js.map